import _ from 'lodash-es'


export class USCredentialsService {

    private $tokenPromise;
        
    constructor(private USCredentials) {
        //this.$token = ''
    }

    SetupCredentials(applicationId) {
        this.$tokenPromise = this.USCredentials.get({ applicationId: applicationId }).$promise
    }

    GetCredentials() {
        return this.$tokenPromise;
    }
}

class USCredentialsServiceProvider implements angular.IServiceProvider {

    instance;

    $get = ['USCredentials',
        (USCredentials) => {
            if (!this.instance)
                this.instance = new USCredentialsService(USCredentials);

            return this.instance;
        }]
}

angular
    .module('app')
    .provider('USCredentialsService', USCredentialsServiceProvider)
